class Customer.Methods.DashboardEventsHandler

  constructor: (@dashboardView) ->
    @configuration = @defaultConfig()

  defaultConfig: =>
    @configuration = {
      NewInteraction:
        webchat: ['openTicket', 'highlightTicket', 'addNewInteraction', 'changeMetricCounters']
        default: ['openTicket', 'highlightTicket']
      TicketAssigned:
        webchat: ['openTicket', 'highlightTicket', 'changeMetricCounters']
        default: ['openTicket', 'highlightTicket']
      WebchatFinalized:
        webchat: ['showWebchatFinalizedEvent']
      TypingEvent:
        webchat: ['showIsTyping']
      OperatorCanWork:
        default: ['operatorCanWork']
    }

  handleEvent: (event) =>
    currentAccountId = Keepcon.currentAccount.id
    newRelicLogger.logSseEvent(event)
    discarded = event.account_id != currentAccountId
    @_logTicketAssignedInfo(event, discarded) if event.event_type == 'TicketAssigned'
    return if discarded
    actions = @eventActions(event)
    _.each(actions, (action) =>
      this[action](event)
    )

  eventActions: (event) =>
    event_type_config = @configuration[event.event_type] || {}
    event_type_config[event.ticket_type] || event_type_config['default']

  openTicket: (event) =>
    @dashboardView.newLoadingTicketView(event.ticket_id, event.ticket_type)

  highlightTicket: (event) =>
    @dashboardView.highlightTab(event.ticket_id, event.ticket_type)

  addNewInteraction: (event) =>
    _.each(event.dialogue.interactions, (interaction) =>
      interaction.triggered_by_sse = true
    )
    @dashboardView.addNewInteraction(event.ticket_id, {
      dialogue: event.dialogue,
      lock_version: event.lock_version,
      status_events: []
    })

  showIsTyping: (event) =>
    @dashboardView.showIsTyping(event.ticket_id)

  changeMetricCounters: (event) =>
    @dashboardView.updateTicketMetrics(event.ticket_id, {metrics_data: event.metrics_data})

  showWebchatFinalizedEvent: (event) =>
    @dashboardView.showWebchatFinalizedEvent(event.ticket_id, event.event_detail)

  operatorCanWork: (event)=>
    noty({
      text: I18n.t('customer.dashboard.acd.operator_can_not_work'),
      type: 'succes',
    }) if event.show_message

  _logTicketAssignedInfo: (event, discarded) ->
    jsLogger.info(
      'Customer.Methods.DashboardEventsHandler | ' +
      "account_id: #{event.account_id} - user_id: #{event.assigned_to_id} - " +
      "event_type: #{event.event_type} - ticket_id: #{event.ticket_id} - " +
      "ticket_type: #{event.ticket_type} - discarded: #{!!discarded}"
    )
